/**
 * Created by chenggong on 2018/3/29.
 */
import Axios from 'axios'

// let host = 'http://127.0.0.1:8000/api'
// let host = 'http://192.168.0.154/api'
// let host = 'https://chenggong.ac.cn/api'
let host = 'https://dss.tirecool.com/api'
let hostApi = 'https://api.tirecool.com'
// let hostApi = 'http://127.0.0.1:5000/'
// let hostLocal = 'http://localhost:5000'
// let hostLocal = 'http://192.168.0.154'
// let host = 'https://ipad.maxtire.com.cn/api'
// let localHost = 'http://127.0.0.1:8000/api'

// 服务器地址
export const serverUrl = host
export const qywxUrl = (corpid, url) => `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${corpid}&redirect_uri=${url}` +
    '&response_type=code&scope=snsapi_base&state=STATE#wechat_redirect'

// 获取Token
export const getToken = params => { return Axios.post(`${host}/token/`, params) }

// 获取用户数据
export const getUserInfo = () => { return Axios.get(`${host}/user/info/1/`) }

// 商品主数据列表
export const getProductList = params => { return Axios.get(`${host}/product/product/`, params) }

// 销售数据DashBroad
export const getDashBroad = params => { return Axios.get(`${host}/sale/dashbroad/`, {params: params}) }
export const getDashBroadV2 = params => { return Axios.get(`${host}/sale/dashbroad_v2/`, {params: params}) }
export const getDashBroadV3 = params => { return Axios.get(`${host}/sale/dashbroad_v3/`, {params: params}) }

// 销售首页
export const getSaleIndex = params => { return Axios.get(`${host}/sale/index/`, {params: params}) }
export const getSaleIndexV2 = params => { return Axios.get(`${host}/sale/index_v2/`, {params: params}) }

// 销售物料组
export const getSaleCategory = params => { return Axios.get(`${host}/sale/category/`, {params: params}) }
export const getSaleCategoryV2 = params => { return Axios.get(`${host}/sale/category_v2/`, {params: params}) }

// 销售排行榜
export const getSaleRank = params => { return Axios.get(`${host}/sale/rank/`, {params: params}) }
export const getSaleRankV2 = params => { return Axios.get(`${host}/sale/rank_v2/`, {params: params}) }
export const getSaleStaffRankV2 = params => { return Axios.get(`${hostApi}/dss/staff/stat`, {params: params}) }

// 商品关键字top10
export const getSaleProductKeywords = params => { return Axios.get(`${host}/sale/product/keyword/`, {params: params}) }

// 商品价格查询
export const getSaleProductPrice = params => {
    if ('pcode' in params) {
        return Axios.get(`${host}/sale/product/` + params.pcode + '/', {params: params})
    } else {
        return Axios.get(`${host}/sale/product/`, {params: params})
    }
}
// 销售订单数据
export const getSaleOrder = params => {
    if ('sap_no' in params) {
        return Axios.get(`${host}/sale/order/` + params.sap_no + '/')
    } else {
        return Axios.get(`${host}/sale/order/`, {params: params})
    }
}

export const getSaleOrderV2 = params => {
    if ('sap_no' in params) {
        return Axios.get(`${host}/sale/order_v2/` + params.sap_no + '/')
    } else {
        return Axios.get(`${host}/sale/order_v2/`, {params: params})
    }
}

// 库存数据(轮胎)
export const getStockTyre = params => { return Axios.get(`${host}/stock/tyre/`, {params: params}) }
// 库存数据(非轮胎)
export const getStockOther = params => { return Axios.get(`${host}/stock/other/`, {params: params}) }
// 库存数据(库龄)
export const getStockAge = params => { return Axios.get(`${host}/stock/age/`, {params: params}) }
// 库存金额(按物料组)
export const getStockTotal = params => { return Axios.get(`${host}/stock/total/`, {params: params}) }
// 会员首页数据
export const getMemberIndex = params => { return Axios.get(`${host}/member/index/`, {params: params}) }
export const getMemberStat = params => { return Axios.get(`${hostApi}/dss/member/stat`, {params: params}) }
export const getMemberSnapshot = params => { return Axios.get(`${hostApi}/dss/member/snapshot`, {params: params}) }
export const postMemberRevisit = data => { return Axios.post(`${hostApi}/dss/member/revisit`, data) }
export const getMemberRevisit = params => { return Axios.get(`${hostApi}/dss/member/revisit`, {params: params}) }

export const getMemberOil = params => { return Axios.get(`${host}/member/oil/`, {params: params}) }
export const getMemberCar = params => { return Axios.get(`${host}/member/car/`, {params: params}) }



// WEBPACK FOOTER //
// ./src/api/api.js